module.exports = __webpack_public_path__ + "img/horizontal_3_1_7042.81c0a9be.png";